import styles from './footer.css';


const Footer = () => (
  <footer>
    <div className={styles.container}>
      <div>&nbsp;</div>
    </div>
  </footer>
);

export default Footer;
